import React from 'react';
import { CSS } from '@dnd-kit/utilities';
import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import type { Transform } from '@dnd-kit/utilities';
import { DashboardKeyValueListKpi } from 'src/services/kpi';
import CardContainer from '../../layouts/CardContainer/CardContainer';
import Badge, { BadgeType } from '../../ui/Badge/Badge';
import './DashboardKeyValueListKpiCard.scss';

export const DashboardKeyValueListKpiCard: React.FC<{
  attributes?: DraggableAttributes;
  listeners?: SyntheticListenerMap;
  setNodeRef?: (node: HTMLElement | null) => void;
  transform?: Transform | null;
  transition?: string;
  data: DashboardKeyValueListKpi;
}> = ({ attributes, listeners, setNodeRef, transform, transition, data }) => {
  const style = {
    transform: CSS.Transform.toString(transform || null),
    transition,
    touchAction: 'none',
  };

  return (
    <CardContainer
      ref={setNodeRef}
      style={style}
      className="parcelStatusCard flex flex-col justify-between"
      label={data.title}
      attributes={attributes}
      listeners={listeners}>
      <div className="grid grid-cols-2 gap-x-40 gap-y-12 items-center mb-16">
        {data.value &&
          data?.value?.map((item, index) => (
            <div
              key={`${item.state} - ${item.total_count} - ${index + 1}`}
              className="col-span-2 lg:col-span-1 flex justify-between items-center w-full">
              <Badge label={item.state} transparent showDot dotFilled expanded type={BadgeType.Neutral4} />
              <div className="quantity">{item.total_count}</div>
            </div>
          ))}
      </div>
    </CardContainer>
  );
};

export default DashboardKeyValueListKpiCard;
